var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { versionHitWitBrandAsset } from './hitwitBranding';
export var HITWIT_LOGO_LIGHT = versionHitWitBrandAsset('https://static.hitwit.ai/hitwit-logo-2026.light.png');
export var HITWIT_LOGO_DARK = versionHitWitBrandAsset('https://static.hitwit.ai/hitwit-logo-2026.dark.png');
export var base64URLEncode = function (str) {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(str)))
        .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};
export var objectToQueryString = function (obj) {
    var keys = Object.keys(obj);
    var keyValuePairs = keys.map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
    });
    return keyValuePairs.join('&');
};
export var getSubdomain = function (url) {
    var domain = url;
    domain = domain.replace("https://www.", "");
    domain = domain.replace("www.", "");
    domain = domain.replace("https://", "");
    domain = domain.replace(".hitwit.ai", "");
    domain = domain.replace("hitwit.ai", "");
    domain = domain.replace(".test", "");
    domain = domain.split(".")[0];
    if (domain === "" || domain.indexOf('localhost') > -1 || (domain.indexOf('test') > -1 && domain.indexOf('test.') == -1))
        return null;
    return domain;
};
export var validateEmail = function (email) {
    return email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
};
export var loadWhiteLabels = function (domains) {
    if (domains === void 0) { domains = {}; }
    return __assign(__assign({}, domains), { "private": {
            domain: "private",
            allowedSignup: ['email', 'google', 'twitter'],
            emailSuffix: "@hitwit.ai",
            forceEmailFromSameDomain: false,
            "logoFull": HITWIT_LOGO_LIGHT,
            "logoFullDark": HITWIT_LOGO_DARK,
            "logo": HITWIT_LOGO_LIGHT,
            height: 30,
        }, "www.hitwit.ai": {
            "logoFull": HITWIT_LOGO_LIGHT,
            "logoFullDark": HITWIT_LOGO_DARK,
            "logo": HITWIT_LOGO_LIGHT,
            allowedSignup: ['email', 'twitter', 'google'],
            height: 30,
        } });
};
export var convertHttpsToS3Url = function (httpsUrl) {
    if (httpsUrl.indexOf("s3://") > -1)
        return httpsUrl;
    try {
        var url = new URL(httpsUrl);
        // Check if it's an S3 URL
        if (!url.hostname.endsWith('.s3.amazonaws.com')) {
            return null; // Not an S3 URL
        }
        // Extract bucket name and key
        var bucketName = url.hostname.split('.s3.amazonaws.com')[0];
        var key = url.pathname.startsWith('/') ? url.pathname.slice(1) : url.pathname;
        // Construct the S3 URI
        return "s3://".concat(bucketName, "/").concat(key);
    }
    catch (error) {
        console.error('Invalid URL:', error);
        return httpsUrl;
    }
};
export var isUrlExpired = function (url) {
    var urlParams = new URLSearchParams(url.split('?')[1]);
    if (urlParams.has('X-Amz-Expires')) {
        var amzDate = urlParams.get('X-Amz-Date');
        var amzExpires = parseInt(urlParams.get('X-Amz-Expires') || '0', 10);
        if (amzDate) {
            // Convert 'X-Amz-Date' to a Date object
            var year = parseInt(amzDate.slice(0, 4), 10);
            var month = parseInt(amzDate.slice(4, 6), 10) - 1; // Month is 0-indexed
            var day = parseInt(amzDate.slice(6, 8), 10);
            var hour = parseInt(amzDate.slice(9, 11), 10);
            var minute = parseInt(amzDate.slice(11, 13), 10);
            var second = parseInt(amzDate.slice(13, 15), 10);
            var amzDateObj = new Date(Date.UTC(year, month, day, hour, minute, second));
            // Calculate the expiry time
            var expiryTime = amzDateObj.getTime() + amzExpires * 1000;
            // Compare with the current time
            return Date.now() > expiryTime;
        }
    }
    else if (urlParams.has('Expires')) {
        var expiresTimestamp = parseInt(urlParams.get('Expires') || '0', 10) * 1000;
        // Compare with the current time
        return Date.now() > expiresTimestamp;
    }
    // If neither parameter exists, consider the URL expired
    return true;
};
export var convertTimestampToSeconds = function (timestamp) {
    // Handle milliseconds if present
    var parts = timestamp.split(',');
    var timeString = parts[0];
    var milliseconds = parts[1] ? Number(parts[1]) / 1000 : 0;
    // Split time parts and pad with zeros if needed
    var timeParts = timeString.split(':').map(Number);
    // Handle different formats:
    // "0:00" -> [minutes, seconds]
    // "00:00:00" -> [hours, minutes, seconds]
    var hours = 0, minutes = 0, seconds = 0;
    if (timeParts.length === 2) {
        minutes = timeParts[0], seconds = timeParts[1];
    }
    else if (timeParts.length === 3) {
        hours = timeParts[0], minutes = timeParts[1], seconds = timeParts[2];
    }
    return hours * 3600 + minutes * 60 + seconds + milliseconds;
};
export var secondsToMMSS = function (seconds) {
    // Handle negative numbers
    if (seconds < 0)
        return '00:00';
    // Convert to minutes and remaining seconds
    var minutes = Math.floor(seconds / 60);
    var remainingSeconds = Math.floor(seconds % 60);
    // Pad with zeros if needed
    var paddedMinutes = String(minutes).padStart(2, '0');
    var paddedSeconds = String(remainingSeconds).padStart(2, '0');
    return "".concat(paddedMinutes, ":").concat(paddedSeconds);
};
export var removeExtension = function (filename) {
    var lastDotIndex = filename.lastIndexOf('.');
    if (lastDotIndex !== -1) {
        var filenameWithoutExtension = filename.substring(0, lastDotIndex);
        return filenameWithoutExtension;
    }
    return filename; // No extension found
};
